module.exports = __webpack_public_path__ + "static/img/target.8cf638b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/target.png
// module id = +NLy
// module chunks = 1